import { $consts } from 'src/plugins'
import { axiosHost, axiosBase } from 'src/plugins/api/axios'
import { apiConfig } from 'src/plugins/api/config'

/**
 * 根据相对接口地址获取当前环境下对应的基础地址
 * @param path 相对接口地址
 * @param prefixPath 接口分割符
 * @returns 
 */
export function getBaseURL (prefixPath?: string) {
  // 得到baseURL，例如：'http://192.168.2.98:3002/api'
  return axiosBase(prefixPath)
}

/**
 * 根据相对接口地址获取完整 api 地址
 * @param path 相对接口地址
 * @returns 
 */
export function getApiURL (path: string) {
  // 得到完整URL，例如：'http://192.168.2.98:3002/api/PF/Login'
  return `${axiosBase(apiConfig.prefixPath)}${path}`
}

/**
 * 获取当前环境下对应的 WebSocket 地址
 * @returns 
 */
export function getSocketURL () {
  return axiosHost('socket', {
    cookieField: $consts['STORAGE/COOKIE_SOCKETURL'],
    envType: 'ws',
    missMatchPort: 3110
  })
}

/**
 * 获取当前环境下对应的 HMI 服务器基址
 * @returns 
 */
export function getHMIBase () {
  return axiosHost('hmi', {
    cookieField: $consts['STORAGE/COOKIE_HMIURL'],
    missMatchPort: 3110
  })
}

/**
 * 获取当前环境下对应的 img 服务器基址
 * @returns 
 */
export function getImgBase () {
  return axiosHost('img')
}